import * as service from './healthsafety.service'
export default {
  data() {
    return {
      compliance_columns: ['TrainingDate', 'Title', 'LocationName', 'TrainingType', 'Category', 'OrganizerName', 'TrainingSessions', 'SessionComplete', 'Actions'],
      optionstable: {
        headings: {
          TrainingDate: 'Date',
          Title: 'Training Name',
          LocationName: 'Training Location',
          TrainingType: 'Type',
          Category: 'Category',
          OrganizerName: 'Organizer',
          TrainingSessions: 'View Training Sessions',
          SessionComplete: 'Session Complete',
          Actions: ''
        },
        labelPosition: 'top',

        /*    isediting: false,
         EditableColID: '',
         role: '',*/
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: [],
        orderBy: {
          column: 'TrainingDate',
          ascending: false
        },
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      Training: {
        Title: '',
        TrainingTypeId: '',
        Category: 1,
        CreatedOn: '',
        OrganizerId: '',
        AreaZone: '',
        TrainingDate: '',
        ComplianceRequirementId: '',
        ComplianceDocumentId: '',
        ReferenceDocumentId: '',
        TrainingSessions: [],
        SupplyItems: [],
        Equipments: [],
        Notes: '',
        LocationId: ''
      },

      displayDate: '',
      cindex: '',

      rules: {

        Title: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        OrganizerId: [

          {
            required: true,
            message: 'This field is required'
          }
        ],
        PlanDate: [{
          type: 'date',
          required: true,
          message: 'This field is required'
        }, ],
        AreaZone: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }

        ],

      },
      value4: [],
      eventDetails: [],
      uindex: '',
      tempUser: [],
      trainings: [],
      equipments: [],
      ttypes: [],
      supplies: [],
      organizers: [],
      compliance: [],
      rdocs: [],
      locationId: '',
      sDetails: [],
      locationName: '',
      modalTitle: '',

      isediting: false,
      isaddding: false,
      sUsers: [],
      filterUser: 1,
      image_data: []
    }
  },
  mounted() {
    let context = this

    this.$router.app.$on('emittedlocation_obj', (data) => {

      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetAllTrainings(context.locationId)
        context.GetAllOrganizers(context.locationId)
      }

      //context.GetEquipments(context.locationId)

    })
    context.GetTrainingTypes()
    context.GetSessionDocuments()
    $('#profile-tab-2').hide()
    this.image_data = []
    this.image_data = new FormData()

  },

  methods: {
    displaySessionUsers(id) {
      this.filterUser = 1
      this.GetSessionDetailsByTrainingId(id)
      $('#UsersModal').modal('show')
    },
    SelectSession(users, index) {
      this.cindex = index
      this.sUsers = users
    },
    addCompliancevit() {
      this.isaddding = true

      this.Training = {
          Title: '',
          TrainingTypeId: '',
          Category: 1,
          CreatedOn: '',
          OrganizerId: '',
          ComplianceDocumentId: '',
          TrainingDate: '',
          AreaZone: '',
          ComplianceRequirementId: '',
          ReferenceDocumentId: '',
          TrainingSessions: [],
          SupplyItems: [],
          Equipments: [],
          Notes: '',
          LocationId: this.locationId
        },
        this.displayDate = ''
      if (this.ttypes) {

        this.Training.TrainingTypeId = this.ttypes[0].Id
        this.GetEquipments(this.Training.TrainingTypeId)
        this.GetSupplyItems(this.Training.TrainingTypeId)
        this.GetMahcCodes()
      }
      this.Training.TrainingDate = new Date()
    },
    viewSessions(data) {

      $('#eventsModel1').modal('show')
      this.eventDetails = data
    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false

    },

    addSession() {

      this.Training.TrainingSessions.push({
        Date: '',
        StartTime: '',
        EndTime: '',
        Topic: '',
        Presenter: '',
        Users: [],
        UserIds: [],
        Attachments: [],
        SessionReferenceDocuments: []

      })

    },
    setFilename: function (e, row) {

      let context = this

      function getExtension(filename) {
        var parts = filename.split('.')
        return parts[parts.length - 1]
      }

      for (var i = 0; i < e.target.files.length; i++) {

        var name = e.target.files[i].name
        var type = e.target.files[i].type
        var size = e.target.files[i].size

        if (type != 'image/jpeg' && type != 'image/jpg' && type != 'image/png' && getExtension(name) != 'docx' && getExtension(name) != 'doc' && getExtension(name) != 'txt' && getExtension(name) != 'pdf') {
          alert('Invalid file format')
          return
        }
        if (size == 0) {
          alert('File is Empty')
          return
        }

        if (size > 5000000) {
          alert('You have exceeded the maximum image size of 5 MB')
          return
        }

        var id = i

        this.image_data.append('Attachments[' + i + ']', e.target.files[i])

      }



    },
    userAppend(val) {


      // alert(JSON.stringify(this.value4))

      this.Training.TrainingSessions[this.uindex].UserIds = val

    },
    addUser(index, data) {

      this.uindex = index
      let context = this

      context.value4 = data

      $('#AttendeesModal').modal('show')
    },
    addSupply() {
      this.Training.SupplyItems.push({

        SupplyItemId: '',
        Quantity: ''

      })

    },

    addEquipment() {
      this.Training.Equipments.push({
        EquipmentId: '',
        Quantity: ''

      })
    },

    removeSession(index) {
      this.Training.TrainingSessions.splice(index, 1)
    },
    removeSupply(index) {
      this.Training.SupplyItems.splice(index, 1)
    },
    removeEquipment(index) {
      this.Training.Equipments.splice(index, 1)
    },
    GetAllOrganizers(id) {
      let context = this
      loader.startLoader()
      service.GetAllOrganizers(id).then(function (response) {

        if (response && response != null) {
          context.organizers = response

        } else {

          context.organizers = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetMahcCodes() {
      let context = this
      loader.startLoader()
      service.GetMahcCodes().then(function (response) {

        if (response && response != null) {
          // context.compliance = response
          $.each(response, function (i, item) {
            $('#compliance_drop').append($('<option>', {
              value: item.Id,
              text: item.Title
            }))
          })

          if (!context.Training.ComplianceRequirementId) {
            context.Training.ComplianceRequirementId = response[0].Id
            //context.Training.ComplianceRequirementId = response[0].Id
            /*  setTimeout(function(){
             $('#compliance_drop > option').each(function(){
             ;
             $(this).parent('select').val(response[0].Id)
             })
             },100)*/
          } else {

            setTimeout(function () {
              $('#compliance_drop > option').each(function () {

                if ($(this).val() == context.Training.ComplianceRequirementId) $(this).parent('select').val(context.Training.ComplianceRequirementId)
              })
            }, 100)

            //context.Training.ComplianceRequirementId = 4

          }

          /*       setTimeout(function() {
           // $('#compliance_drop option:eq(1)').prop('selected', true);
           $('#compliance_drop option:eq(0)').remove();
           }, 300);*/

        } else {

          context.compliance = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    getSupplyEquipment() {

      this.GetEquipments(this.Training.TrainingTypeId)
      this.GetSupplyItems(this.Training.TrainingTypeId)
    },
    GetSessionDocuments() {
      let context = this
      loader.startLoader()
      service.GetSessionDocuments().then(function (response) {

        if (response && response != null) {
          context.rdocs = response

        } else {

          context.rdocs = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetTrainingTypes() {
      let context = this
      loader.startLoader()
      service.GetTrainingTypes().then(function (response) {

        if (response && response != null) {
          context.ttypes = response

        } else {

          context.ttypes = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetSupplyItems(typeid) {
      let context = this
      loader.startLoader()
      service.GetSupplyItems(typeid).then(function (response) {

        if (response && response != null) {
          context.supplies = response

        } else {

          context.supplies = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    UpdateSessionCompletness() {
      let context = this
      loader.startLoader()
      var ac = []
      var fdata = new FormData()
      if (this.sDetails) {

        this.sDetails.map(function (item, index) {
          ac.push({
            SessionId: item.Id,
            SessionCompletedUsersId: []
          })
          if (item.Users.length > 0) {
            item.Users.map(function (item1, index1) {
              if (item1.IsSessionCompleted) {
                ac[index].SessionCompletedUsersId.push(item1.Id)
              }

            })
          }

        })

      }

      service.UsersCompletedSession(ac).then(function (response) {

        context.$notify({
          title: 'Success',
          message: 'Sessions Updated',
          type: 'success'
        })
        $('#UsersModal').modal('hide')
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },
    GetSessionDetailsByTrainingId(tid) {
      let context = this
      loader.startLoader()
      service.GetSessionDetailsByTrainingId(tid).then(function (response) {

        if (response && response != null) {
          context.sDetails = response
          context.sUsers = response[0].Users

        } else {

          context.sDetails = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetEquipments(typeid) {
      let context = this
      loader.startLoader()
      service.GetEquipments(typeid).then(function (response) {

        if (response && response != null) {
          context.equipments = response

        } else {

          context.equipments = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    showFtab() {
      $('#fli').addClass('active')
      $('#sli').removeClass('active')
      $('#profile-tab-1').show()
      $('#profile-tab-2').hide()
    },
    showStab() {

      $('#sli').addClass('active')
      $('#fli').removeClass('active')
      $('#profile-tab-2').show()
      $('#profile-tab-1').hide()

      this.$router.app.$emit('emitTrain', 'train')

    },
    GetAllTrainings(locationId) {
      let context = this
      loader.startLoader()
      service.GetAllTrainings(locationId).then(function (response) {

        if (response && response != null) {
          context.trainings = response
          tooltip.startTooltip(50)
        } else {

          context.trainings = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    del: function (data) {
      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteTraining(ID).then(function (response) {

          context.GetAllTrainings(context.locationId)
          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.Id
      let context = this
      context.EditableColID = ID
      context.Training = deepcopy(data.row)
      context.Training['Id'] = ID

      if (context.Training.TrainingSessions) {
        if (context.Training.TrainingSessions.length > 0) {

          context.Training.TrainingSessions.map(function (item, index) {
            if (item.StartTime) {
              item.StartTime = context.$options.filters.ftime(item.StartTime)
            }
            if (item.EndTime) {
              item.EndTime = context.$options.filters.ftime(item.EndTime)
            }

            context.Training.TrainingSessions[index]['UserIds'] = []
            item.Users.map(function (item1, index1) {


              if (item1.UserId != null) {
                context.Training.TrainingSessions[index]['UserIds'].push(item1.UserId)
              }

            })


          })
        }
        // context.Training.Category = parseInt(context.Training.Category)
        this.displayDate = this.$options.filters.fdate(new Date())
        if (context.Training.TrainingDate) {
          context.Training.TrainingDate = new Date(context.Training.TrainingDate)
        }

      }


      /*      context.addMaintenance['PlanDate'] = new Date(data.row['PlanDate'])*/
      context.isediting = true

      if (context.Training.Category == 'Pre-service') {
        context.Training.Category = 1
      }
      if (context.Training.Category == 'In-Service') {
        context.Training.Category = 2
      }

      this.GetEquipments(this.Training.TrainingTypeId)
      this.GetSupplyItems(this.Training.TrainingTypeId)
      this.GetMahcCodes()
    },

    AddTraining(formName) {

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          /*          context.addMaintenance['LocationId'] = context.locationId
           context.addMaintenance['PlanDate'] = context.$options.filters.fdate(context.addMaintenance['PlanDate'])*/

          /*  context.Training.TrainingSessions.map(function(item,index){

           item.Date = new Date(item.Date)


           });*/
          context.Training.TrainingSessions.map(function (item, index) {

            item.Date = context.$options.filters.fdate(item.Date)

          })
          if (context.Training.Category == '1') {
            context.Training.Category = 'Pre-service'
          }
          if (context.Training.Category == '2') {
            context.Training.Category = 'In-Service'
          }
          context.Training.TrainingDate = context.$options.filters.fdate(context.Training.TrainingDate)
          service.AddTraining(context.Training).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Training  Created',
              type: 'success'
            })
            context.GetAllTrainings(context.locationId)
            context.isediting = false
            context.isaddding = false

          }, (error) => {
            /*            context.addMaintenance['PlanDate'] = new Date(context.addMaintenance['PlanDate'])*/

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'TRAINING -1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    UpdateTraining(formName) {

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          /*          context.addMaintenance['LocationId'] = context.locationId
           context.addMaintenance['PlanDate'] = context.$options.filters.fdate(context.addMaintenance['PlanDate'])*/

          context.Training.TrainingSessions.map(function (item, index) {

            item.Date = context.$options.filters.fdate(item.Date)

          })

          if (context.Training.Category == 1) {
            context.Training.Category = 'Pre-service'
          }
          if (context.Training.Category == 2) {
            context.Training.Category = 'In-Service'
          }
          context.Training.TrainingDate = context.$options.filters.fdate(context.Training.TrainingDate)
          service.UpdateTraining(context.Training).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Training Details Updated',
              type: 'success'
            })
            context.GetAllTrainings(context.locationId)
            context.isediting = false
            context.isaddding = false

          }, (error) => {
            /*            context.addMaintenance['PlanDate'] = new Date(context.addMaintenance['PlanDate'])*/

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'TRAINING -2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    }

  },
}



// WEBPACK FOOTER //
// ./src/pages/HealthSafety/training.controller.js